<template>
    <div class="vhp-footer-content container-width">
        <section class="vhp-footer-section-menu">
            <div
              class="section-menu-wrap desktop-hide"
              v-for="menu in menus"
              :key="menu.key"
            >
              <router-link :to="menu.path">
                <strong>{{$t(menu.text)}}</strong>
              </router-link>
            

              <div
                v-for="submenu in menu.childrens"
                :key="submenu.key"
                class="section-submenu-wrap"
              >
                <router-link :to="submenu.path">{{$t(submenu.text)}}</router-link>
              </div>
            </div>

          
          <div class="mobile-section-menu-wrap desktop-show">
            <ul
                v-for="(menu, idx) in menus" 
                :key="menu.key"
            >
              <li 
              >
                <div class="parent-item" @click="onClickArrow(idx)" >
                  <a v-if="menu.childrens.length > 0" :class="{ active : activeMenuIndex === idx}"> 
                    <strong>{{$t(menu.text)}}</strong>
                    <div class="arrow" v-if="menu.childrens">
                      <span/>
                      <span/>
                    </div>
                  </a>

                  <router-link :to="menu.path"  v-else>
                    <strong>{{$t(menu.text)}}</strong>
                  </router-link>
                </div>

                <div v-if="menu.childrens.length > 0 && activeMenuIndex === idx" :class="{ active : activeMenuIndex === idx}">
                  <div 
                    class="header-allmenu-item"
                    v-for="submenu in menu.childrens" 
                    :key="submenu.key"
                  >
                    <a v-if="submenu.outlink" @click="selectedMenu = null, openLink(submenu.path)" class="outlink">
                      {{$t(submenu.text)}}
                      <img alt="external-link" src="@/assets/image/external-link.svg" height="12" style="margin-left:6px;"/>
                    </a>
                    <router-link v-else :to="submenu.path">
                      {{$t(submenu.text)}}
                    </router-link>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          
          

          <div
            class="section-menu-addon"
          >
            <div>
              <router-link  to="/privacy"><strong>{{$t('개인정보 처리방침')}}</strong><img alt="external-link" src="@/assets/image/external-link.svg" height="10" style="margin-left:6px;"/></router-link>
            </div>
            <!-- <div>
              <a href="https://vazil-vhp.s3.ap-northeast-2.amazonaws.com/resources/vazil.pdf" download="Vazil_Company_Introduction(2023).pdf" target="_blank"><strong>{{$t('기업소개서')}}</strong><img alt="external-link" src="@/assets/image/external-link.svg" height="10" style="margin-left:6px;"/></a>
            </div> -->
          </div>
        </section>

        <section class="vhp-footer-section-info">
          <span class="section-info-logo">
            <img alt="logo" src="@/assets/image/logo.svg"  height="18"/>
          </span>

          <div class="section-info-main">
            <div>
              {{$t('(주)바질컴퍼니')}}
            </div>
            <div>
              {{$t('대표')}}: {{$t('황희경')}} | {{$t('사업자등록번호')}}: 180-88-00809 
            </div>
            <div>
              {{$t('회사주소')}}
            </div>
            <div>
              T 055-724-2999 | E admin@vazilcompany.com
            </div>
            <p>
              © Copyright {{ new Date().getFullYear() }} {{$t('저작권')}}
            </p>
          </div>

          

          <div class="section-menu-sns">
            <button @click="$utils.openLink('https://blog.naver.com/vazilcompany')">
              <img alt="globe" src="@/assets/image/naver-blog.svg" width="20" height="20"/>
            </button>
            <button @click="$utils.openLink('https://www.youtube.com/@user-yo5xu2gv4q')">
              <img alt="globe" src="@/assets/image/youtube.svg" width="20" height="20"/>
            </button>
          </div>

          <span class="section-info-copyright">

            
          <vhp-select 
            v-model="familySite"
            :items="[{text:$t('브릿지 AI'), value:'https://www.vridgeai.com'}]" 
            item-key="text"
            item-value="value"
            :placeholder="$t('패밀리 사이트')" 
          />
          </span>
        </section>
    </div>
  </template>
  
  <script>
  export default {
    name: 'vhpFooter',
    props: {
      menus: {
        type: Array,
        default: ()=> {
          return []
        }
      }
    },
    watch:{
      familySite(){
        if(this.familySite){
          this.$utils.openLink(this.familySite)
          this.familySite = ''
        }
      }
    },
    data() {
      return{
        familySite:'',
        activeMenuIndex: -1
      }
    },
    methods:{
      onClickArrow(idx) {
        if(idx === this.activeMenuIndex) {
          this.activeMenuIndex = -1
          return
        }
        this.activeMenuIndex = idx
      }
    }
  }
  </script>

<style lang="scss" src="./vhpFooter.scss"></style>
  
  